// The shelf: every journal as a bound cover, at /journals.
//
// Ported from design_handoff_oreia/web/journals-web.jsx (Shelf) with the class names kept.

import { useNavigate } from 'react-router-dom';
import { useJournals } from './JournalsProvider';
import { Cover } from './Cover';
import { IconFolderPlus, IconLock, IconPlus } from '../components/Icons';
import { JournalModeSwitch } from './JournalModeSwitch';
import { Notice, Spinner } from '../components/ui';

export function JournalsShelf() {
  const { collections, isLoading, error } = useJournals();
  const navigate = useNavigate();

  return (
    <>
      <div className="ohead">
        <div className="obrand">
          <span className="nm" style={{ fontSize: 22 }}>Journal</span>
        </div>
        <div className="olock">
          <IconLock /> Private
        </div>
      </div>

      <JournalModeSwitch mode="journals" />

      <div className="shelf-head">
        <span className="atm-group-label" style={{ margin: 0 }}>
          Your journals · {collections.length}
        </span>
        <button className="shelf-new" onClick={() => navigate('/journals/new')}>
          <IconPlus /> New journal
        </button>
      </div>
      <p className="shelf-note">
        Collections gather entries by theme. An entry can live in several journals at once — and
        always stays in your main feed.
      </p>

      {error ? <Notice tone="danger">{error}</Notice> : null}

      {isLoading ? (
        <Spinner label="Opening your journals…" />
      ) : (
        <div className="shelf-grid">
          {collections.map((collection) => (
            <button
              className="shelf-item"
              key={collection.id}
              onClick={() => navigate(`/journals/${collection.id}`)}
            >
              <Cover
                cover={collection.coverId}
                title={collection.title || 'Untitled journal'}
                subtitle={collection.subtitle}
              />
              <span className="shelf-meta">
                {collection.entryIds.length}{' '}
                {collection.entryIds.length === 1 ? 'entry' : 'entries'}
              </span>
            </button>
          ))}

          {/* Present even on an empty shelf, where it is the only thing to do — a screen whose
              single instruction is a button in the corner is a screen people leave. */}
          <button className="shelf-item new" onClick={() => navigate('/journals/new')}>
            <span className="shelf-newcard">
              <IconFolderPlus />
              <span>New journal</span>
            </span>
            <span className="shelf-meta">Name it, dress it</span>
          </button>
        </div>
      )}

      <div style={{ height: 60 }} />
    </>
  );
}
